import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconBinOutline from '@adv-mt/mt-svg-icons/lib/BinOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

const BASE_CLASS = 'mt-ConfirmDeleteModal'

const ConfirmDeleteModal = ({instantOfferAppraisal, isLoading = false, isOpen, onC2bClick, onClose, onConfirm}) => {
  const {i18n} = useContext(Context)

  const hasC2bOffer = Boolean(instantOfferAppraisal)

  const deleteButton = {
    color: 'error',
    customCallBack: onConfirm,
    isLoading,
    text: (
      <span className={`${BASE_CLASS}-buttonText`}>
        <IconBinOutline size={ATOM_ICON_SIZES.medium} />
        {i18n.t('MY_ADS.CONFIRM_DELETE.DELETE')}
      </span>
    )
  }

  const content = hasC2bOffer
    ? {
        buttons: {
          cancelButton: deleteButton,
          confirmButton: {
            customCallBack: onC2bClick,
            text: <span className={`${BASE_CLASS}-buttonText`}>{i18n.t('MY_ADS.CONFIRM_DELETE.SELL_TO_PRO')}</span>
          }
        },
        children: (
          <>
            <p className={`${BASE_CLASS}-text`}>{i18n.t('MY_ADS.CONFIRM_DELETE.C2B_TEXT')}</p>
            <p className={`${BASE_CLASS}-price`}>{i18n.c(instantOfferAppraisal)}</p>
            <p className={`${BASE_CLASS}-priceNote`}>{i18n.t('MY_ADS.CONFIRM_DELETE.C2B_PRICE_NOTE')}</p>
          </>
        ),
        title: i18n.t('MY_ADS.CONFIRM_DELETE.C2B_TITLE')
      }
    : {
        buttons: {
          cancelButton: deleteButton,
          confirmButton: {
            customCallBack: onClose,
            text: <span className={`${BASE_CLASS}-buttonText`}>{i18n.t('MY_ADS.CONFIRM_DELETE.KEEP')}</span>
          }
        },
        children: <p className={`${BASE_CLASS}-text`}>{i18n.t('MY_ADS.CONFIRM_DELETE.TEXT')}</p>,
        title: i18n.t('MY_ADS.CONFIRM_DELETE.TITLE')
      }

  return (
    <MoleculeModal
      closeOnEscKeyDown
      closeOnOutsideClick
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={BASE_CLASS}>
        <ModalBasicContent stepsContent={[content]} />
      </div>
    </MoleculeModal>
  )
}

ConfirmDeleteModal.displayName = 'ConfirmDeleteModal'

ConfirmDeleteModal.propTypes = {
  instantOfferAppraisal: PropTypes.number,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onC2bClick: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ConfirmDeleteModal
